import {submitForm} from '@vo/js/modules/form'

export const executeRecaptcha = (form) => {
    if (!window.grecaptcha || window.voRecaptchaForm) {
        return
    }

    window.voRecaptchaForm = form

    window.grecaptcha.execute()
}

const initRecaptcha = () => {
    if (document.querySelector('.g-recaptcha') && document.querySelector('[data-recaptcha]')) {
        const script = document.querySelector('#recaptcha-script')
        script?.setAttribute('src', script?.getAttribute('data-src'))
        script?.removeAttribute('data-src')
    }
}

export default () => {
    window.voFormRecaptchaSuccess = (token) => {
        /**
         * @type {HTMLFormElement|null}
         */
        const form = window.voRecaptchaForm
        window.recaptchaToken = token

        delete window.voRecaptchaForm

        // Add reCAPTCHA verifications fields if reCAPTCHA enabled
        const verifyRecaptcha = form.querySelector('#verify') != null
        if (window.recaptchaToken && verifyRecaptcha) {
            const siteKeyInput = document.createElement('input')
            siteKeyInput.type = 'hidden'
            siteKeyInput.name = 'recaptcha_token'
            siteKeyInput.value = window.recaptchaToken

            form.appendChild(siteKeyInput)
        }

        submitForm(form)
    }

    initRecaptcha()
}
